import React, { ReactNode, FunctionComponent } from 'react';

// Custom components
import SidebarProvider from './SidebarContext/SidebarProvider';
import SidebarRoot from './SidebarRoot';
import { PositionType } from './SidebarContext/SidebarContext';

export interface ISidebarControl {
  id?: string
  initialOpenId?: string
  initialOpenHeading?: string;
  onTabChange?: () => void
  position?: PositionType
  children: ReactNode
}

const SidebarControl: FunctionComponent<ISidebarControl> = (props) => {

  const { id, initialOpenId, onTabChange, initialOpenHeading, position, children} = props;
  return (
    <SidebarProvider initialOpenId={initialOpenId} onTabChange={onTabChange} initialOpenHeading={initialOpenHeading} position={position}> 
     <SidebarRoot id={id} initialOpenId={initialOpenId} >
      {/* <Box sx={{with: 10, height: 10, bgColor: "red"}} /> */}
        {children}
      </SidebarRoot>
    </SidebarProvider>
  );
};

export default SidebarControl;
